/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class KarenGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_MULTIPLIER = "NumbersMultiplier";
    static BITMAP_FONT_XWAYS = "xWaysFont";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FS_BACKGROUND: string = "freespinBackground";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(KarenGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(KarenGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(KarenGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/NumbersMultiplier.fnt"),
                    new BitmapFontAsset(KarenGameAssets.BITMAP_FONT_XWAYS, "fonts/bitmapfonts/xWaysFont.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },

            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json")
                ],
                animations: {
                    "button_inactive": "reel2button/Button_inactive",
                    "button_off": "reel2button/Button_off_active",
                    "button_on": "reel2button/Button_On_active",
                    "restricted_enhanced_bet": "reel2button/Sign_Broken",
                    "background_single": "mult/multSticker_single",
                    "background_double": "mult/multSticker_double",
                    "inf_background_single": "mult/InfectiousmultSticker_single",
                    "inf_background_double": "mult/InfectiousmultSticker_double",
                    "reel_Frame": "ReelFrame/ReelFrame",
                    "reel_frame_tr6": "ReelFrame/panel_top_r6",
                    "reel_frame_tr5": "ReelFrame/panel_top_r5",
                    "reel_frame_tr4": "ReelFrame/panel_top_r4",
                    "reel_frame_tr3": "ReelFrame/panel_top_r3",
                    "reel_frame_br6": "ReelFrame/panel_bottom_r6",
                    "reel_frame_br5": "ReelFrame/panel_bottom_r5",
                    "reel_frame_br4": "ReelFrame/panel_bottom_r4",
                    "reel_frame_br3": "ReelFrame/panel_bottom_r3",
                    "StickyFrame": "StickyFrame/StickyFrame",
                    "FSBillboard": "ReelFrame/FSBillboard",
                    "gameLogo": "ReelLogo/ReelLogo",
                    "gameLogoPost": "ReelLogo/LogoPost",
                    "bubble": "reel2button/Bubble",
                    "deluxBonusMealBanner": "DeluxBonusMealBanner",
                    "deluxeSpinCountText": "+3"
                },
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "mainHigh",
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json"),
                ],
                animations: {
                },
                autoLoad: [AssetQualityLevel.HIGH],
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                ],
                animations: {
                    //"bubble":"bubble"
                }
            },
            {
                name: "symbols",
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {},
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("intro", "spine/IntroAnimation.json"),
                    new SpineAsset("scatter_reel_expand", "spine/scatter_reel_expand.json"),
                    new SpineAsset("win_overlays_m1", "spine/win_overlays_m1_120_210.json"),
                    new SpineAsset("win_overlays_m2", "spine/win_overlays_m2_120_210.json"),
                    new SpineAsset("win_overlays_m3", "spine/win_overlays_m3_120_210.json"),
                    new SpineAsset("win_overlays_m4", "spine/win_overlays_m4_120_210.json"),
                    new SpineAsset("win_overlays_m5", "spine/win_overlays_m5_120_210.json"),
                    new SpineAsset("win_overlays_mx", "spine/win_overlays_mx_120_84.json"),
                    new SpineAsset("win_overlays_lx_84", "spine/win_overlays_lx_120_84.json"),
                    new SpineAsset("win_overlays_lx_210", "spine/win_overlays_lx_120_210.json"),
                    new SpineAsset("x_way", "spine/x_way.json"),
                    new SpineAsset("anticipation", "spine/anticipation.json"),
                    new SpineAsset("wild_antc", "spine/anticipation.json"),
                    new SpineAsset("wild", "spine/wild.json"),
                    new SpineAsset("scatter", "spine/scatter.json"),
                    new SpineAsset("xWayinfectious_0", "spine/infectious_xway.json"),
                    new SpineAsset("xWayinfectious", "spine/x_way_infectious.json"),//small
                    new SpineAsset("big_win_animation", "spine/big_wins.json"),
                    new SpineAsset("fs_intro_outro", "spine/fs_intro_outro.json"),
                    new SpineAsset("infectious_frame", "spine/infectious_frame.json"),
                    new SpineAsset("WinCapScreen", "spine/WinCapScreen.json"),
                    new SpineAsset("backgroundAnim", "spine/BG_Animation.json"),
                    new SpineAsset("stickyXWay2", "spine/sticky_xway2.json"),
                    new SpineAsset("stickyXWay3", "spine/sticky_xway3.json"),
                    new SpineAsset("stickyXWay4", "spine/sticky_xway4.json"),
                    new SpineAsset("stickyXWay5", "spine/sticky_xway5.json"),
                    new SpineAsset("signs", "spine/signs.json"),
                    new SpineAsset("countUpEffect", "spine/count_up_effect.json"),
                    new SpineAsset("splashes_banner", "spine/LetDown_Banner.json")
                ],
                animations: {}
            }
        ]
    };
}
